import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";

export default function Testimonials() {
  const [ref, api] = useEmblaCarousel({ loop: true, align: "start" });
  const [sel, setSel] = useState(0);
  const onSelect = useCallback(() => { if (api) setSel(api.selectedScrollSnap()); }, [api]);
  useEffect(() => {
    if (!api) return undefined;
    api.on("select", onSelect);
    const t = setInterval(() => api.scrollNext(), 6000);
    return () => { clearInterval(t); api.off("select", onSelect); };
  }, [api, onSelect]);

  return (
    <div className="my-20 bg-mist py-16 text-forest-deep lg:my-28 lg:py-20" data-testid="testimonial-slider" data-no-orbit>
      <div className="wrap">
        <div className="flex items-end justify-between gap-6">
          <div>
            <p className="eyebrow text-forest">Word on the street</p>
            <p className="mt-3 font-display text-3xl font-semibold sm:text-4xl">From UK festivals, foodies & restaurants</p>
          </div>
          <div className="flex shrink-0 gap-2">
            <button data-testid="testimonial-prev-btn" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="grid h-12 w-12 place-items-center rounded-full border border-forest-deep/30 hover:border-forest hover:text-forest"><ArrowLeft className="h-4 w-4" /></button>
            <button data-testid="testimonial-next-btn" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="grid h-12 w-12 place-items-center rounded-full bg-forest text-white"><ArrowRight className="h-4 w-4" /></button>
          </div>
        </div>
        <div className="mt-10 overflow-hidden" ref={ref}>
          <div className="flex">
            {TESTIMONIALS.map((t, i) => (
              <figure key={i} className="min-w-0 shrink-0 grow-0 basis-full pr-4 sm:basis-1/2 lg:basis-1/3" data-testid={`testimonial-${i}`}>
                <div className={`flex h-full flex-col justify-between rounded-[1.25rem] border p-7 transition-colors duration-500 ${sel === i ? "border-forest/60 bg-white" : "border-forest-deep/15 bg-white/40"}`}>
                  <Quote className="h-7 w-7 text-forest" />
                  <blockquote className="mt-5 font-display text-2xl italic leading-snug">“{t.quote}”</blockquote>
                  <figcaption className="mt-8 border-t border-forest-deep/15 pt-4">
                    <p className="font-medium">{t.name}</p>
                    <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-forest-deep/80">{t.handle} · {t.date}</p>
                  </figcaption>
                </div>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
